var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['popular-combos-odds', {
    active: _vm.active,
    'swiper-web': _vm.isWeb,
    'popular-combos-odds--up': _vm.isUp,
    'popular-combos-odds--down': _vm.isDown
  }],on:{"click":_vm.handleSelect}},[(_vm.isUp || _vm.isDown)?_c('i',{class:['m-icon-arrow', {
      'up': _vm.isUp,
      'down': _vm.isDown
    }]}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.odds)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }